import {
  useEffect,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Image,
  Text,
  Stack,
  Spinner
} from '@chakra-ui/react'
import {
  getBlogPreference,
  getPosts,
  handleOpenModal,
  setBlogParent,
  setBlogRepostData,
  setBlogRepostParent,
  setComments,
  setPosts,
  setOpenPopupBlogs,
  setChosenNotifBlog,
  setFromEngagementPanel,
  setHideNotification
} from 'store'
import { ImagesPng } from 'assets/images'
import { isNotMobile } from 'utils/helpers'
import {
  MODAL_SECTION,
  PENDING,
  SUCCEEDED
} from 'utils/constants'
import { COLORS } from 'utils/styles'

export const CommunityBlogs = ({
  getBlogPreferenceStatus,
  getEngagementItemsStatus,
  getEventDataStatus,
  getPostsStatus,
  getProfileItemStatus,
  getSavedEventsStatus,
  NotificationSections,
  postMakeNotificationSeenAllStatus,
  preferredBlogs,
  rowTitle,
  singleMarkerUpdateStatus,
  setNotificationSectionPage
}) => {
  const dispatch = useDispatch()
  const [itemData, setItemData] = useState([])
  const [itemTitle, setItemTitle] = useState('')
  const [sectionPage, setSectionPage] = useState('')
  const [unseenBlogsCount, setUnseenBlogsCount] = useState(0)

  const goToPane = () => {
    dispatch(setNotificationSectionPage({
      key: sectionPage,
      title: itemTitle === 'Edit Blog Preference' ? 'Subscriptions' : itemTitle
    }))

    setItemTitle('')
    setSectionPage('')
  }

  useEffect(() => {
    if (
      getPostsStatus === SUCCEEDED
      && itemTitle !== ''
      && sectionPage !== ''
    ) {
      dispatch(setChosenNotifBlog(itemData))

      if (isNotMobile()) {
        const notifDrawer = document.querySelector('#chakra-modal-notification-drawer')
        if (notifDrawer && notifDrawer.offsetWidth * 3 >= document.querySelector('body').offsetWidth) {
          dispatch(setHideNotification(true))
          dispatch(handleOpenModal({ isOpen: false, section: MODAL_SECTION.RightSection }))
        }
      }

      dispatch(setOpenPopupBlogs(true))
    }
  }, [getPostsStatus])

  useEffect(() => {
    if (
      getBlogPreferenceStatus === SUCCEEDED
      && itemTitle !== ''
      && sectionPage !== ''
    ) {
      goToPane()
    }
  }, [getBlogPreferenceStatus])

  useEffect(() => {
    if (preferredBlogs?.length) {
      let unseen = 0

      preferredBlogs.forEach((blog) => {
        if (blog?.new_post_count > 0) {
          unseen += blog?.new_post_count
        }
      })

      setUnseenBlogsCount(unseen)
    } else {
      setUnseenBlogsCount(0)
    }
  }, [preferredBlogs])

  return (
    <Card key="community-blogs" boxShadow="none" marginTop="0px !important" background="#c4c3c7">
      <CardHeader display="flex" alignItems="center" padding="0 25px" background="#feeb88">
        <Box textAlign="left" paddingRight="10px">
          {rowTitle}
        </Box>
        {unseenBlogsCount > 0 && (
          <Stack direction="row" alignItems="center">
            <Box
              textAlign="center"
              background={COLORS.gold}
              width={unseenBlogsCount > 99 ? '25px' : '17px'}
              height="17px"
              borderRadius="full"
              position="relative"
            >
              <Box
                fontSize="12px"
                fontWeight={500}
                transform="translate(-50%, -50%)"
                top="50%"
                left="50%"
                position="absolute"
              >
                {unseenBlogsCount > 99 ? '99+' : unseenBlogsCount}
              </Box>
            </Box>
          </Stack>
        )}
      </CardHeader>

      <CardBody
        padding="5px"
        minHeight="130px"
        maxHeight="130px"
        verflow="hidden"
      >
        <Box
          sx={{
            margin: '0 5px',
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'row',
            gap: '0px'
          }}
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          {preferredBlogs.map((item) => (
            <Stack key={item.id}>
              <Box
                key={item.id}
                sx={{
                  minWidth: '120px',
                  marginTop: '5px'
                }}
                data-name="preferredBlog"
                position="relative"
                pointerEvents={
                  getPostsStatus === PENDING
                  || postMakeNotificationSeenAllStatus === PENDING
                  || getProfileItemStatus === PENDING
                  || getEventDataStatus === PENDING
                  || getEngagementItemsStatus === PENDING
                  || getBlogPreferenceStatus === PENDING
                  || singleMarkerUpdateStatus === PENDING
                  || getSavedEventsStatus === PENDING
                  || sessionStorage.getItem('openProfileAfterAnimation')
                  || sessionStorage.getItem('openEventAfterAnimation')
                    ? 'none'
                    : 'auto'
                }
                opacity={
                  getPostsStatus === PENDING
                  || postMakeNotificationSeenAllStatus === PENDING
                  || getProfileItemStatus === PENDING
                  || getEventDataStatus === PENDING
                  || getEngagementItemsStatus === PENDING
                  || getBlogPreferenceStatus === PENDING
                  || singleMarkerUpdateStatus === PENDING
                  || getSavedEventsStatus === PENDING
                  || sessionStorage.getItem('openProfileAfterAnimation')
                  || sessionStorage.getItem('openEventAfterAnimation')
                    ? 0.7
                    : 1
                }
                overflow="hidden"
              >
                <Image
                  key={item.id}
                  cursor="pointer"
                  width="108px"
                  height="108px"
                  objectFit="cover"
                  src={item.blogImage ?? ImagesPng.DefaultImage}
                  title={item.title ?? 'blog image'}
                  alt={item.title ?? 'blog image'}
                  borderRadius="5px"
                  pointerEvents={
                    getPostsStatus === PENDING
                    || postMakeNotificationSeenAllStatus === PENDING
                    || getProfileItemStatus === PENDING
                    || getEventDataStatus === PENDING
                    || getEngagementItemsStatus === PENDING
                    || getBlogPreferenceStatus === PENDING
                    || singleMarkerUpdateStatus === PENDING
                    || getSavedEventsStatus === PENDING
                    || sessionStorage.getItem('openProfileAfterAnimation')
                    || sessionStorage.getItem('openEventAfterAnimation')
                      ? 'none'
                      : 'auto'
                  }
                  onClick={() => {
                    let waitTime = 0
                    if (document.querySelector('#chakra-modal-event-drawer')) {
                      document.querySelector('#force-close-event-drawer')?.click()
                      waitTime = 900
                    }

                    setTimeout(() => {
                      dispatch(setPosts([]))
                      dispatch(setComments([]))
                      dispatch(setBlogParent([]))
                      dispatch(setFromEngagementPanel({}))
                      dispatch(setBlogRepostData([]))
                      dispatch(setBlogRepostParent([]))

                      localStorage.removeItem('friendReqID')

                      if (item.type === null) {
                        try {
                          document.querySelector('#blog-modal-back-button').click()
                          document.querySelector('#force-close-blog-drawer').click()
                        } catch {
                          //
                        }

                        dispatch(getBlogPreference())

                        setItemTitle(item.title)
                        setSectionPage(NotificationSections.BLOG_PREFERENCE)
                      } else {
                        dispatch(getPosts({
                          type: item.type,
                          id: item.id
                        }))

                        setItemData(item)
                        setItemTitle(item.title)
                        setSectionPage(NotificationSections.BLOG_LIST)
                      }
                    }, waitTime)
                  }}
                />
                {
                  item?.new_post_count
                    ? (
                      <Text
                        position="absolute"
                        top="15%"
                        right="0"
                        transform="translate(-50%, -50%)"
                        backgroundColor={COLORS.red}
                        textAlign="center"
                        width="35px"
                        borderRadius="5px"
                        pointerEvents="none"
                      >
                        {item?.new_post_count > 99 ? '99+' : item?.new_post_count}
                      </Text>
                    )
                    : ''
                }

                {
                  item.type === 'subscribed'
                    ? (
                      <Text
                        position="absolute"
                        bottom="2px"
                        padding="2px 5px"
                        fontSize="25px"
                        color={COLORS.white}
                        textShadow={
                          '1.3px 0 0 black, -1.3px 0 0 black, 0 1.3px 0 black, 0 -1.3px 0 black, '
                          + '1.3px 1.3px 0 black, -1.3px 1.3px 0 black, 1.3px -1.3px 0 black, -1.3px -1.3px 0 black'
                        }
                        lineHeight="28px"
                        textAlign="center"
                        width="108px"
                        noOfLines={2}
                        pointerEvents="none"
                      >
                        {(item.title).split('\'')[0]}
                      </Text>
                    )
                    : ''
                }

                {
                  (
                    getPostsStatus === PENDING
                    || getBlogPreferenceStatus === PENDING
                  )
                  && item.title === itemTitle
                    ? (
                      <Center position="absolute">
                        <Spinner
                          key={item.id}
                          width="80px"
                          height="80px"
                          position="sticky"
                          marginLeft="14px"
                          marginTop="-108px"
                          zIndex={5}
                        />
                      </Center>
                    ) : ''
                }
              </Box>
            </Stack>
          ))}
        </Box>
      </CardBody>
    </Card>
  )
}
